export function addQueryParameterToUrl(url: string, name: string, value: string): string {
    const hasQuery = url.indexOf("?") !== -1;
    !hasQuery ? (url += "?") : (url += "&");

    const paramKeyValue = `${name}=${encodeURIComponent(value)}`;
    url += paramKeyValue;

    return url;
}
